/* eslint-disable no-param-reassign */
import L from 'leaflet';

const SVG_SRC = '/maps-buttons/t.svg';
const SVG_STYLE = `
  position: relative;
  right: 0px;
  width: 34px;
  height: 34px;
  transition: right 0.3s;
`;
const CONTAINER_STYLE = `
  cursor: pointer;
  height: 34px;
  display: inline-block;
`;

const P_STYLE = `
  margin-top: 0.5rem;
  overflow: hidden;
  text-overflow: ellipsis;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const TEXT_STYLE = `
  background-color: white;
  border-radius: 4px;
  z-index: -1;
  white-space: nowrap;
  float:left;
  width: fit-content;
  max-width: 0px;
  vertical-align: middle;
  height: 34px;
  opacity; 0;
  transition: max-width 0.3s, padding 0.2s 0.1s, opacity 0.3s;
`;

L.Control.TitleButton = L.Control.extend({
  options: {
    position: 'topleft'
  },

  initialize(name, options) {
    L.Util.setOptions(this, options);

    this.name = name;
  },

  onAdd(map) {
    this.map = map;
    map.titleButton = this;
    this.container = L.DomUtil.create('div');
    this.textContainer = L.DomUtil.create('div', '', this.container);
    this.svg = L.DomUtil.create('img', '', this.container);
    const { container, textContainer, svg } = this;
    container.title = 'Title';
    container.style.cssText = CONTAINER_STYLE;
    svg.style.cssText = SVG_STYLE;
    svg.src = SVG_SRC;
    textContainer.innerHTML = `<p style="${P_STYLE}">${this.name}</p>`;
    textContainer.style.cssText = TEXT_STYLE;
    container.clicked = false;

    L.DomEvent.disableClickPropagation(container);
    L.DomEvent.on(container, 'click', this.clickTitle, this);
    map.on('click', this.collapseTitle, this);
    map.on('mouseout', this.collapseTitle, this);

    return container;
  },
  clickTitle() {
    if (!this.container.clicked) {
      this.expandTitle();
    } else {
      this.collapseTitle();
    }
  },

  expandTitle() {
    this.container.clicked = true;
    this.svg.style.right = '34px';
    this.textContainer.style.maxWidth = `${this.map.getSize().x / 2}px`;
    this.textContainer.style.padding = '0px 39px 0px 10px';
    this.textContainer.style.opacity = '1';
  },

  collapseTitle() {
    if (this.container.clicked) {
      this.container.clicked = false;
      this.svg.style.right = '0px';
      this.textContainer.style.maxWidth = '0px';
      this.textContainer.style.padding = '0px';
      this.textContainer.style.opacity = '0';
    }
  }
});

L.control.titlebutton = (layer, opts) => new L.Control.TitleButton(layer, opts);

/**
 * Adds a title button to the map.
 *
 * @param {object} leafletMap - The leaflet map.
 * @param {object} name - The title to add.
 */
const customTitleButton = (leafletMap, name) => L.control.titlebutton(name).addTo(leafletMap);

export default customTitleButton;
